module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 var response = content.response 
__p+=' ';
 var productSuggestions =
content.productSuggestions 
__p+=' ';
 var collectionSuggestions =
content.collectionSuggestions 
__p+=' ';
 var pageSuggestions =
content.pageSuggestions 
__p+=' ';
 var articleSuggestions =
content.articleSuggestions 
__p+=' ';
 var querySuggestions = content.querySuggestions

__p+=' ';
 var searchPageResults = content.searchPageResults 
__p+='\n\n<div id="predictive-search-results" role="listbox">\n  <div\n    id="predictive-search-results-groups-wrapper"\n    class="predictive-search__results-groups-wrapper"\n  >\n    ';
 if (productSuggestions && productSuggestions.length >= 1) { 
__p+='\n    <div class="predictive-search-products">\n      <h3 id="predictive-search-products" class="predictive-search__heading">\n        Products\n      </h3>\n      <ul\n        id="predictive-search-results-products-list"\n        class="predictive-search__results-list"\n        role="group"\n        aria-labelledby="predictive-search-products"\n      >\n        ';
 $(productSuggestions).each(function() { 
__p+='\n        <li\n          id="predictive-search-option-product"\n          class="predictive-search__list-item"\n          role="option"\n          aria-selected="false"\n        >\n          <a\n            href="'+
((__t=( this.url ))==null?'':__t)+
'"\n            class="predictive-search__item link link--text"\n            tabindex="-1"\n          >\n            <div class="predictive-search__item-content">\n              <img\n                class="predictive-search__image"\n                src="'+
((__t=(this.featured_image.url ))==null?'':__t)+
'"\n                alt="'+
((__t=(this.featured_image.alt ))==null?'':__t)+
'"\n                width="50"\n                height="50"\n              />\n            </div>\n            <div class="predictive-search__item-content">\n              <p\n                class="predictive-search__item-heading predictive-search__item-product-result"\n              >\n                '+
((__t=( this.title ))==null?'':__t)+
'\n              </p>\n              <p class="predictive-search__item-product-result price">\n                '+
((__t=( this.price ))==null?'':__t)+
'\n              </p>\n            </div>\n          </a>\n        </li>\n        ';
 }) 
__p+='\n      </ul>\n    </div>\n    ';
 } 
__p+=' ';
 if (collectionSuggestions && collectionSuggestions.length >= 1) {
    
__p+='\n    <div class="predictive-search-collections">\n      <h3 id="predictive-search-collections" class="predictive-search__heading">\n        Collections\n      </h3>\n      <ul\n        id="predictive-search-results-collections-list"\n        class="predictive-search__results-list"\n        role="group"\n        aria-labelledby="predictive-search-collections"\n      >\n        ';
 $(collectionSuggestions).each(function() { 
__p+='\n        <li\n          id="predictive-search-option-collection"\n          class="predictive-search__list-item"\n          role="option"\n          aria-selected="false"\n        >\n          <a\n            href="'+
((__t=( this.url ))==null?'':__t)+
'"\n            class="predictive-search__item link link--text"\n            tabindex="-1"\n          >\n            <div class="predictive-search__item-content">\n              <p\n                class="predictive-search__item-heading predictive-search__item-collection-result"\n              >\n                '+
((__t=( this.title ))==null?'':__t)+
'\n              </p>\n            </div>\n          </a>\n        </li>\n        ';
 }) 
__p+='\n      </ul>\n    </div>\n    ';
 } 
__p+=' ';
 if (pageSuggestions && pageSuggestions.length >= 1) { 
__p+='\n    <div class="predictive-search-pages">\n      <h3 id="predictive-search-pages" class="predictive-search__heading">\n        Pages\n      </h3>\n      <ul\n        id="predictive-search-results-pages-list"\n        class="predictive-search__results-list"\n        role="group"\n        aria-labelledby="predictive-search-pages"\n      >\n        ';
 $(pageSuggestions).each(function() { 
__p+='\n        <li\n          id="predictive-search-option-page"\n          class="predictive-search__list-item"\n          role="option"\n          aria-selected="false"\n        >\n          <a\n            href="'+
((__t=( this.url ))==null?'':__t)+
'"\n            class="predictive-search__item link link--text"\n            tabindex="-1"\n          >\n            <div class="predictive-search__item-content">\n              <p\n                class="predictive-search__item-heading predictive-search__item-page-result"\n              >\n                '+
((__t=( this.title ))==null?'':__t)+
'\n              </p>\n            </div>\n          </a>\n        </li>\n        ';
 }) 
__p+='\n      </ul>\n    </div>\n    ';
 } 
__p+=' ';
 if (articleSuggestions && articleSuggestions.length >= 1) { 
__p+='\n    <div class="predictive-search-articles">\n      <h3 id="predictive-search-articles" class="predictive-search__heading">\n        Articles\n      </h3>\n      <ul\n        id="predictive-search-results-articles-list"\n        class="predictive-search__results-list"\n        role="group"\n        aria-labelledby="predictive-search-articles"\n      >\n        ';
 $(articleSuggestions).each(function() { 
__p+='\n        <li\n          id="predictive-search-option-article"\n          class="predictive-search__list-item"\n          role="option"\n          aria-selected="false"\n        >\n          <a\n            href="'+
((__t=( this.url ))==null?'':__t)+
'"\n            class="predictive-search__item link link--text"\n            tabindex="-1"\n          >\n            <div class="predictive-search__item-content">\n              <p\n                class="predictive-search__item-heading predictive-search__item-article-result"\n              >\n                '+
((__t=( this.title ))==null?'':__t)+
'\n              </p>\n            </div>\n          </a>\n        </li>\n        ';
 }) 
__p+='\n      </ul>\n    </div>\n    ';
 } 
__p+=' ';
 if (querySuggestions && querySuggestions.length >= 1) { 
__p+='\n    <div class="predictive-search-queries">\n      <h3 id="predictive-search-queries" class="predictive-search__heading">\n        Queries\n      </h3>\n      <ul\n        id="predictive-search-results-queries-list"\n        class="predictive-search__results-list"\n        role="group"\n        aria-labelledby="predictive-search-queries"\n      >\n        ';
 $(querySuggestions).each(function() { 
__p+='\n        <li\n          id="predictive-search-option-query"\n          class="predictive-search__list-item"\n          role="option"\n          aria-selected="false"\n        >\n          <a\n            href="'+
((__t=( this.url ))==null?'':__t)+
'"\n            class="predictive-search__item link link--text"\n            tabindex="-1"\n          >\n            <div class="predictive-search__item-content">\n              <p\n                class="predictive-search__item-heading predictive-search__item-query-result"\n              >\n                '+
((__t=( this.text ))==null?'':__t)+
'\n              </p>\n            </div>\n          </a>\n        </li>\n        ';
 }) 
__p+='\n      </ul>\n    </div>\n    ';
 } 
__p+='\n  </div>\n</div>\n';
}
return __p;
};
